module.exports = __webpack_public_path__ + "img/CARTE-VISITE-VERSO.a407d150.jpg";